import { render } from "./MetaMaskImport.vue?vue&type=template&id=ff1d1b1a&scoped=true"
import script from "./MetaMaskImport.vue?vue&type=script&lang=js"
export * from "./MetaMaskImport.vue?vue&type=script&lang=js"

import "./MetaMaskImport.vue?vue&type=style&index=0&id=ff1d1b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1d1b1a"]])

export default __exports__